// @ts-nocheck
export function omit(obj: object, keysToOmit: string[]) {
  return Object.keys(obj)
    .filter((key) => keysToOmit.indexOf(key) < 0)
    .reduce((newObj, key) => Object.assign(newObj, { [key]: obj[key] }), {});
}
